import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M9.106 9.106a.75.75 0 0 1 1.06 0L16 14.939l5.834-5.833a.75.75 0 0 1 1.06 1.06L17.061 16l5.833 5.834a.75.75 0 0 1-1.06 1.06L16 17.061l-5.834 5.833a.75.75 0 1 1-1.06-1.06L14.939 16l-5.833-5.834a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }));
export {
  t as default
};
